export default __webpack_public_path__ + "static/media/users-white.de77f981.svg";